// extracted by mini-css-extract-plugin
export var container = "_58-0";
export var error = "_58-9";
export var label = "_58-5";
export var light = "_58-6";
export var md = "_58-3";
export var sm = "_58-2";
export var thin = "_58-8";
export var thinBold = "_58-7";
export var vertical = "_58-4";
export var xs = "_58-1";